import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { TQC2070_R01Dto } from "./Dto_TQC2070_R01";
import { deleteData, getData, postData, putData } from "src/utils/axios/serverHelper";
import { TQC2070_R01Filter } from "./Store_TQC2070_R01";

const baseUrl = `${config.apiUrl}/TQC2070_R01`;

/**
 * API 파라미터 빌더 함수 (중복 제거)
 */
const buildApiParams = (
	filter: TQC2070_R01Filter,
	additionalParams?: Record<string, any>
): Record<string, any> => {
	return {
		searchAnalysisDt: filter.searchAnalysisDt || undefined,
		listLength: filter.listLength || undefined,
		...additionalParams,
	};
};

/**
 * 기본 조회
 */
export const getTQC2070_R01List = async (
	option: string = "",
	filter: TQC2070_R01Filter,
	listLength: number = 0
) => {
	const url = option ? `${baseUrl}/${option}` : baseUrl;
	const params = buildApiParams(filter, {
		listLength: listLength || undefined,
	});
	return await getData<ResponseDto<TQC2070_R01Dto[]>>(url, { params });
};

/**
 * Search 옵션 조회
 */
export const getTQC2070_R01Search = async (params: Partial<TQC2070_R01Filter>) => {
	const url = `${baseUrl}/search`;
	return await getData<ResponseDto<TQC2070_R01Dto[]>>(url, { params });
};

/**
 * Refetch 옵션 조회
 */
export const getTQC2070_R01Refetch = async (
	filter: TQC2070_R01Filter,
	refetchListLength: number = 0
) => {
	const url = `${baseUrl}/refetch`;
	const params = buildApiParams(filter, {
		refetchListLength: refetchListLength || undefined,
	});
	return await getData<ResponseDto<TQC2070_R01Dto[]>>(url, { params });
};

/**
 * 등록
 */
export const createTQC2070_R01 = async (data: TQC2070_R01Dto) => {
	return await postData<TQC2070_R01Dto, ResponseDto<TQC2070_R01Dto>>(baseUrl, data);
};

/**
 * 수정
 */
export const updateTQC2070_R01 = async (data: TQC2070_R01Dto) => {
	return await putData<TQC2070_R01Dto, ResponseDto<TQC2070_R01Dto>>(baseUrl, data);
};

/**
 * 삭제
 */
export const deleteTQC2070_R01 = async (analysisDt: string) => {
	const url = `${baseUrl}/${analysisDt}`;
	return await deleteData<ResponseDto<any>>(url);
};

/**
 * 엑셀 다운로드 (기본)
 */
export const downloadExcel_TQC2070_R01 = async (params: Partial<TQC2070_R01Filter>) => {
	const url = `${baseUrl}/excel`;
	return await getData<ResponseDto<string>>(url, { params });
};

/**
 * 엑셀 다운로드 (Search 옵션)
 */
export const downloadExcelSearch_TQC2070_R01 = async (params: Partial<TQC2070_R01Filter>) => {
	const url = `${baseUrl}/excel/search`;
	return await getData<ResponseDto<string>>(url, { params });
};

/**
 * 엑셀 다운로드 (Refetch 옵션)
 */
export const downloadExcelRefetch_TQC2070_R01 = async (
	filter: TQC2070_R01Filter,
	refetchListLength: number = 0
) => {
	const url = `${baseUrl}/excel/refetch`;
	const params = buildApiParams(filter, {
		refetchListLength: refetchListLength || undefined,
	});
	return await getData<ResponseDto<string>>(url, { params });
};

/**
 * 아연액(Zn) 분석 보고서 PDF 다운로드
 */
export const downloadPdfZinc_TQC2070_R01 = async (yearMonth: string) => {
	const url = `${baseUrl}/pdf/${yearMonth}`;
	return await getData<Blob>(url, { 
		responseType: 'blob',
		headers: {
			'Accept': 'application/pdf'
		}
	});
};

/**
 * 가성소다액(NaOH) 분석 보고서 PDF 다운로드
 */
export const downloadPdfNaoh_TQC2070_R01 = async (yearMonth: string) => {
	const url = `${baseUrl}/pdf-naoh/${yearMonth}`;
	return await getData<Blob>(url, { 
		responseType: 'blob',
		headers: {
			'Accept': 'application/pdf'
		}
	});
};

